<template>
  <v-card flat class="my-0">
    <v-card-text>
      <v-textarea
        rows="1"
        v-model="field.cnnStr"
        :auto-grow="true"
        v-bind:label="$t('ConnectionString')"
        :error-messages="cnnStrErrors"
        @input="validator.field.cnnStr.$touch()"
        @blur="validator.field.cnnStr.$touch()"
      />
      <v-tabs>
        <v-tab>{{ $t("Query") }}</v-tab>
        <v-tab>{{ $t("NoResultQuery") }}</v-tab>
        <v-tab-item>
          <div class="sql-editor">
            <codemirror v-model="field.command" :options="cmOption" />
          </div>
        </v-tab-item>
        <v-tab-item>
          <div class="sql-editor">
            <codemirror v-model="field.noResultQuery" :options="cmOption" />
          </div>
        </v-tab-item>
      </v-tabs>
      <v-row>
        <v-col>
          <v-switch
            v-model="field.multiValue"
            v-bind:label="$t('Multivalue')"
          ></v-switch>
        </v-col>
        <v-col>
          <v-switch
            v-model="field.useOdbc"
            v-bind:label="$t('ODBC')"
            input-value="true"
          />
        </v-col>
        <v-col>
          <v-select
            :loading="loading"
            :multiple="field.multiValue"
            v-bind:label="$t('Test')"
            item-text="text"
            item-value="id"
            :items="testItems"
            ><template v-slot:append-outer>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn small icon @click="test" v-on="on">
                    <v-icon>mdi-database-check</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("Test") }}</span>
              </v-tooltip>
            </template>
          </v-select>
        </v-col>
      </v-row>
    </v-card-text>
    <ListFieldParamsModal
      :ref="listFieldParamsModalKey"
      @on-saved="executeTestQuery"
    />
  </v-card>
</template>

<script>
import Utils from "@/ecm/common/Utils";
import ContentTypeService from "@/services/ContentTypeService";
import ListFieldParamsModal from "@/components/administration/contentType/fields/ListFieldParamsModal";
import { codemirror } from "vue-codemirror";
// import base style
import "codemirror/lib/codemirror.css";
import "codemirror/mode/sql/sql";
import "codemirror/theme/solarized.css";

export default {
  components: {
    codemirror,
    ListFieldParamsModal,
  },
  props: {
    field: {
      type: Object,
      default: () => ({}),
    },
    validator: {
      type: Object,
      default: () => ({}),
    },
    contentTypeFields: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      loading: false,
      testItems: [],
      cmOption: {
        tabSize: 4,
        styleActiveLine: true,
        lineNumbers: true,
        line: true,
        mode: "text/x-mssql",
        theme: "solarized light",
      },
      listFieldParamsModalKey: "listFieldParamsModalKey",
    };
  },
  computed: {
    cnnStrErrors() {
      const errors = [];
      if (!this.validator.field.cnnStr.$dirty) return errors;
      !this.validator.field.cnnStr.required &&
        errors.push(this.$t("RequiredField"));
      return errors;
    },
  },
  methods: {
    test() {            
      this.testItems = [];
      var paramItems = this.contentTypeFields
        .filter((f) => this.field.command.includes(`{${f.code}}`))
        .map((f) => {
          return {
            code: f.code,
            name: f.name,
            multiValue: f.multiValue,
            value: "",
          };
        });
      if (paramItems.length > 0) {
        this.$refs[this.listFieldParamsModalKey].edit(paramItems);
      } else {
        this.executeTestQuery(paramItems);
      }
    },
    executeTestQuery(paramItems) {
      var test = {
        ConnectionString: this.field.cnnStr,
        Query: this.field.command,
        NoResultQuery: this.field.noResultQuery || "",
        UseODBC: this.field.useOdbc,
        Parameters: paramItems.map((p) => {
          return {
            Name: p.code,
            Value: p.value,
            Multivalue: p.multiValue,
          };
        }),
      };
      this.loading = true;
      ContentTypeService.testDynamicList(test)
        .then((data) => {
          Utils.toast.success(this.$t("SuccessfulTest"));
          this.testItems = data;
        })
        .catch((error) => {
          // error
        })
        .then(() => {
          //always
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss">
.sql-editor {
  .CodeMirror {
    border: 1px solid #eee;
    height: auto !important;
    min-height: 200px !important;
    /*max-height: 500px;*/
    line-height: 20px;
  }
  .CodeMirror-scroll {
    min-height: 200px;
  }
}
</style>